import React, { Component, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../css/style.css";
import "../css/purpleresponsive.css";
import renderHTML from "react-render-html";
import $ from "jquery";
import { apiCalling, awsAPIUrlcommon } from "../apiService";
import "react-datepicker/dist/react-datepicker.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SlotList from "../home/slotList";
import { Helmet } from "react-helmet";
import Star from "../image/ida/star.png"
import DoctorImg from "../image/ida/doctor.png"
import Bookappointment from "../Sparsh/bookappointment"
import { IoCallOutline } from "react-icons/io5";
import { HiOutlineEnvelope } from "react-icons/hi2";
import { SlLocationPin } from "react-icons/sl";
import { RiArrowRightSLine } from "react-icons/ri";
import Arrowleft from "../image/ida/Arrow_left_light.png"
const folderName = window.sessionStorage.getItem("homeName");
const Header = React.lazy(() => import("../" + folderName + "/header"));
const Footer = React.lazy(() => import("../" + folderName + "/footer"));
console.log("🚀 ~ Header:", Header)
const inperson =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/inperson.png";
const chatg =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/chatg.png";
const phoneg =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/phoneg.png";
const videog =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/videog.png";
const info =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/infosquare.png";
const speciality =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/stethoscope.png";
const service =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/checklist1.png";
const hospital =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/hospitals.png";
export default class DoctorDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      professionalStatement: "",
      doctorBD: [],
      drSpecialization: [],
      hospitalDetails: [],
      drServices: [],
      appointmentSlotDay: [],
      hospitalImages: [],
      serviceOffered: [],
      Specialities: [],
      officeDetails: [],
      testing: "yyy",
      calFlag: "",
      seoTitle: "",
      description: "",
    };
  }

  isLoginCheck() {
    if (folderName === "IMAHospitals") {
      return true;
    } else {
      let flag = true;
      if (!window.sessionStorage.getItem("isLogin")) {
        $("#ForgotPasswordWrap").hide();
        $("#SignupWrap").hide();
        $("#signInWrapDiv").hide();
        flag = false;
      }
      return flag;
    }
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
    $(".react-datepicker__time-container").show();
    $(".react-datepicker__navigation").hide();
    $(".timeClose").show();
  };
  addToFavourites(e) {
    if (this.isLoginCheck() === true) {
      if (e.target.checked) {
        const jsonData = {
          method: "POST",
          body: JSON.stringify({
            functionName: "addToFavourites",
            siteId: window.sessionStorage.getItem("siteId"),
            userId: window.sessionStorage.getItem("userId"),
            favouriteUserId: this.state.doctorBD.userId,
          }),
        };
        apiCalling(jsonData).then((data) => {
          if (data.success === "1") {
            alert(data.successMessage);
          }
        });
        $("#fav").attr("disabled", true);
      }
    }
  }
  DrDetailLiked() {
    $("#dr-detail-liked .imgdislike").toggle();
    $("#dr-detail-liked .imgliked").toggle();
  }
  componentWillReceiveProps(nextProps) {
    // console.log("hiiiiiiiiiiiiiiiiiiiiii", this.props.match.url);
    // console.log("hiiiiiiiiiiiiiiiiiiiiii", nextProps.match.url);
    if (nextProps.match.url !== this.props.match.url) window.location.reload();
  }
  componentDidMount() {
    let slug = this.props.match.params.slug;
    slug = slug.split("-");
    // console.log(this.props, "this is the params of this page");
    let doctorId = slug[0];
    if (folderName === null) {
      window.sessionStorage.setItem("pathname", window.location.pathname);
      window.location.href = "/";
    }
    $(".loader").show();
    $(".generalFlag").hide();
    let self = this;
    window.sessionStorage.setItem("AppFlag", "NA");

    $("#callLink").hide();
    $("#chatLink").hide();
    $("#videoLink").hide();
    $("#emailLink").hide();
    $("#bookLink").hide();
    //let doctorId;

    // if (self.props.location.doctorId) {
    //   window.sessionStorage.setItem("doctorPID", self.props.location.doctorId);
    //   doctorId = self.props.location.doctorId;
    // } else {
    //   doctorId = window.sessionStorage.getItem("doctorPID");
    // }
    if (doctorId) {
      window.sessionStorage.setItem("doctorPID", doctorId);
      doctorId = doctorId;
    } else {
      doctorId = window.sessionStorage.getItem("doctorPID");
    }

    const doctorDetails = {
      method: "POST",
      body: JSON.stringify({
        functionName: "doctorProfile",
        siteId: window.sessionStorage.getItem("siteId"),
        doctorId: doctorId,
      }),
    };
    // console.log(doctorDetails.body);
    apiCalling(doctorDetails).then((data) => {
      if (data.success === "1") {
        $(".loader").hide();

        this.setState({
          doctorBD: data.doctorData[0],
          seoTitle: data.doctorData[0].seoTitle,
          description: data.doctorData[0].description,
        });
        window.sessionStorage.setItem(
          "doctorName",
          data.doctorData[0].doctorName
        );
        this.setState({
          officeDetails: data.doctorData[0].officeDetails,
        });
        this.setState({
          serviceOffered: data.doctorData[0].serviceOffered,
        });
        this.setState({
          Specialities: data.doctorData[0].specialization,
        });

        this.setState({
          hospitalDetails: data.doctorData[0].hospitalDetails,
        });
        window.sessionStorage.setItem(
          "hospitalName",
          data.doctorData[0].hospitalDetails[0].name
        );
        this.setState({
          hospitalImages: data.doctorData[0].galleryImages,
        });

        // this.getCalenderData(data.doctorData[0].hospitalDetails[0].hospitalId);
        data.doctorData[0].specialization.map((sp) => {
          this.setState({
            drSpecialization: this.state.drSpecialization.concat(
              sp.specialization
            ),
          });
        });

        data.doctorData[0].services.map((sp) => {
          //alert(sp);
          if (sp === "Call a Doctor") {
            $("#callLink").show();
          }
          if (sp === "Messaging") {
            $("#chatLink").show();
          }
          if (sp === "Video Chat") {
            $("#videoLink").show();
          }
          if (sp === "Email Consult") {
            $("#emailLink").show();
          }
          if (sp === "Book Appointment") {
            $("#bookLink").show();
          }
        });
        // });
        // alert(data.doctorData[0].Favouriteflag);
        if (data.doctorData[0].Favouriteflag === "1") {
          $("#dr-detail-liked .imgdislike").toggle();
          $("#dr-detail-liked .imgliked").toggle();
        }
      } else {
        alert(data.errorMessage);
      }
    });
    // $("#dr-detail-liked .imgliked").hide();
    // $(".timeClose").on("click", function () {
    //   $(this).hide();
    //  $(".react-datepicker__time-container").hide();
    //   $(".react-datepicker__navigation").show();
    //  });
    // self.showService();
    if (this.props.location.doctorList) {
      for (let i = 0; i < this.props.location.doctorList.length; i++) {
        if (
          this.props.location.doctorList[i].doctorId.toString() === doctorId
        ) {
          $("#fav").attr("checked", true);
          break;
        }
      }
    }
  }
  componentWillMount() {}

  showService() {
    //alert(this.state.hospitalDetails);
    this.state.hospitalDetails.map((hos) => {
      // alert(hos.phoneNumber);
    });
  }

  isLoginValidate(doctorId, hospitalId, flagOption, bySlot, selDate, selTime) {
    //alert("inside" + hospitalId);
    if (this.isLoginCheck() === true) {
      if (doctorId) {
        // alert('ok')
        window.sessionStorage.setItem("loginValidate", "");
        window.sessionStorage.setItem("appDocId", doctorId);
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("flagOption", flagOption);
        window.sessionStorage.setItem("bySlot", bySlot);
        window.sessionStorage.setItem("selDate", selDate);
        window.sessionStorage.setItem("selTime", selTime);
        window.sessionStorage.setItem("doctor_details", "1");
        //alert();
        window.location.href = "/patient/bookappointment";
      } else if (window.sessionStorage.getItem("appDocId")) {
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("flagOption", flagOption);
        window.location.href = "/patient/bookappointment";
      } else {
      }
    } else {
      window.sessionStorage.setItem("loginValidate", "book");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("flagOption", flagOption);
      window.sessionStorage.setItem("bySlot", bySlot);
      window.sessionStorage.setItem("selDate", selDate);
      window.sessionStorage.setItem("selTime", selTime);
      window.sessionStorage.setItem("doctor_details", "1");
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }
  changeHospital() {
    let hosid = $("#hospitalDrop").val();
    $(".bookLink").hide();
    $(".videoLink").hide();
    $(".callLink").hide();
    $(".callLinkChat").hide();

    $("#bookLink" + hosid).show();
    $("#videoLink" + hosid).show();
    $("#callLink" + hosid).show();
    $("#callLinkChat" + hosid).show();
  }
  chatmessageClickValidate(
    doctorId,
    hospitalId,
    chatDoctorPanelId,
    textChatPrice
  ) {
    $(".loader").show();
    const jsonData = {
      method: "POST",
      body: JSON.stringify({
        functionName: "messageChatFree",
        chatDoctorPanelId: chatDoctorPanelId,
        memberId: window.sessionStorage.getItem("userId"),
        doctorId: doctorId,
        hospitalId: hospitalId,
      }),
    };
    // console.log(jsonData.body);
    apiCalling(jsonData).then((data) => {
      if (data.success === "1") {
        $(".loader").show();
        window.sessionStorage.setItem("API_KEY", data.API_KEY);
        window.sessionStorage.setItem("sessionId", data.sessionId);
        window.sessionStorage.setItem("token", data.token);
        window.sessionStorage.setItem("appDocId", doctorId);
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("chatDoctorPanelId", data.chatGroupId); //chatDoctorPanelId);
        window.location.href = "/chat/chatmessage";
      } else {
        // this.chatmessageClickValidate(
        //   doctorId,
        //   hospitalId,
        //   chatDoctorPanelId,
        //   textChatPrice
        // );
        alert(data.errorMessage);
      }
    });
  }
  chatmessageClick(doctorId, hospitalId, chatDoctorPanelId, textChatPrice) {
    if (this.isLoginCheck() === true) {
      this.chatmessageClickValidate(
        doctorId,
        hospitalId,
        chatDoctorPanelId,
        textChatPrice
      );
    } else {
      window.sessionStorage.setItem("loginValidate", "TextChatFree");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatDoctorPanelId);
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }
  isLoginValidateTextChatWithPayment(
    doctorId,
    hospitalId,
    chatdoctorpanelid,
    messaging_cost
  ) {
    if (this.isLoginCheck() === true) {
      window.sessionStorage.setItem("loginValidate", "");
      // alert(doctorId);
      // alert(hospitalId);
      // alert(chatdoctorpanelid);
      // alert(messaging_cost);
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatdoctorpanelid);
      window.sessionStorage.setItem("messaging_cost", messaging_cost);
      window.location.href = "/patient/textchatpayment";
    } else {
      window.sessionStorage.setItem("loginValidate", "TextChatPay");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatdoctorpanelid);
      window.sessionStorage.setItem("messaging_cost", messaging_cost);
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }
  render() {
    var dateSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            swipeToSlide: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            swipeToSlide: true,
          },
        },
      ],
    };

    return (
      <div className="purpleWrap">
        <Suspense fallback={<div></div>}>
          <section>
            <Header />
          </section>
        </Suspense>
        <Helmet>
          <title>{this.state.seoTitle}</title>
          <meta name="description" content={this.state.description} />
        </Helmet>
        <div className="container-fluid px-0">
          <div className="telehealthfeaturehead text-md-left">
            <div className="breadcrumb-main mb-1">
              <ul className="bread-crumb-ul">
                <li className="breadcrumb-light">Home</li>
                <li>
                  <RiArrowRightSLine />
                </li>
                <li className="breadcrumb-light">Doctors</li>
                <li>
                  <RiArrowRightSLine />
                </li>
                <li>{this.state.doctorBD.doctorName}</li>
              </ul>

            </div>
            <span>
              <img src={Arrowleft} alt="arrowleft" className="img-fluid mr-2 cursor-pointer"/>
            </span>
            {this.state.doctorBD.doctorName}
          </div>
          <div
            className="drDetailServicemainTab drListMain px-5"
            style={{ float: "none" }}
          >
            <Tabs>
              <TabList>
                 <Tab>
                  <span className="drDetSpanUnderline">Overview</span>
                </Tab>
                 <Tab>
                  <span className="drDetSpanUnderline">Book Appoiment</span>
                </Tab>
                <Tab>
                  <span className="drDetSpanUnderline">specialities</span>
                </Tab>
                <Tab>
                  <span className="drDetSpanUnderline">service offered</span>
                </Tab>
                <Tab>
                  <span className="drDetSpanUnderline">office details</span>
                </Tab>
              </TabList>

              <TabPanel>
                <div className="doctorDetailMain float-none">
                  <div className="doctorDetailProfile">
                    <h4 className="mb-0 sub-heading text-left">
                      Overview
                    </h4>
                    <div className="doctorDetailLeft" style={{position:"unset", transform:"none"}}>
                      <div className="doctorDetailImg">
                        <img
                        className="doctorDetailImage"
                          src={DoctorImg}
                          width="150"
                          height="150"
                          alt=""
                        ></img>
                      </div>
                      <h5 class="drDetName mt-3 mb-1">
                        {this.state.doctorBD.doctorName}
                        {/* {this.state.doctorBD.lastName} */}
                        {"   "}
                        {/* {this.state.doctorBD.doctorEducation} */}
                      </h5>
                      <p class="drspecialist-textCont mb-1">
                        Perfect 32 Multispeciality
                      </p>
                      <div className="d-flex justify-content-center">
                        <span class="drspecialistName">
                          {this.state.doctorBD.primarySpeciality}
                        </span>
                        <div className="top-header-right ml-2">
                          <img src={Star} alt="star" className="img-fluid pr-1" width="17" 
                          style={{marginTop:"-3px"}}/>
                          4.8
                        </div>
                      </div>

                      <div>
                        <h4 className="mb-0 sub-heading text-left mt-5 mb-3">
                          Basic info
                        </h4>
                        <p class="drspecialist-content text-left d-flex mb-2">
                          <span className="mr-2" style={{lineHeight:"16px"}}><HiOutlineEnvelope size={17}/></span>
                          <span className="drspecialist-span">                          
                            hello@website.com
                          </span>
                        </p>
                        <p class="drspecialist-content text-left d-flex mb-2">
                          <span className="mr-2" style={{lineHeight:"16px"}}><SlLocationPin size={17}/></span>
                          <span className="drspecialist-span">                          
                            Pushpanjali Auditorium, Choorakad, Thrippunithura, Ernakulam, Kerala, India - 682301
                          {/* {this.state.doctorBD.address} */}
                          </span>
                        </p>
                        <p class="drspecialist-content text-left d-flex mb-2">
                          <span className="mr-2" style={{lineHeight:"16px"}}><IoCallOutline size={17}/></span>
                          <span className="drspecialist-span">                          
                            +91 9878XXX585
                          </span>
                        </p>
                      </div>
                      {/*<p class="drspecialist-text mb-0">{this.state.doctorBD.city}</p> */}
                      {/* {this.state.hospitalDetails.length !== 1 && (
                        <p className="mb-0">
                          <select
                            class="drspecialist-hospital"
                            onClick={(e) => this.changeHospital()}
                            id="hospitalDrop"
                          >
                            {this.state.hospitalDetails.map((hospial) => {
                              return (
                                <option value={hospial.hospitalId}>
                                  {hospial.name}
                                </option>
                              );
                            })}
                          </select>
                        </p>
                      )} */}
                      {/* <span class="profileAvailable">
                        <img src={correct} width="17"></img>Available
                      </span> */}
                    </div>
                    {/* <div
                      className="drServiceMain"
                      id={"drServiceMain" + this.props.consti}
                    >
                      <div className="drService-subhead">SERVICES:</div>

                      {this.state.hospitalDetails.map((hos, index) => {
                        let services = hos.hospitalServices;
                        //let priceDetails = hos.priceDetails;
                        // alert(services);
                        let bookShow = "none";
                        let vcShow = "none";
                        let auShow = "none";
                        let chat = "none";
                        let show = index === 0 ? "block" : "none";
                        services.map((it) => {
                          // alert(it.serviceName)
                          if (
                            it.serviceName === "Book Appointment" &&
                            it.status === 1
                          ) {
                            bookShow = "Book Appointment";
                          }
                          if (it.serviceName === "Video Chat" && it.status === 1) {
                            vcShow = "Video Chat";
                          }
                          if (it.serviceName === "Call a Doctor" && it.status === 1) {
                            auShow = "Call a Doctor";
                          }
                          if (it.serviceName === "Messaging" && it.status === 1) {
                            chat = "Messaging";
                          }
                        });
                        // alert(hos.priceDetails[0].textChatPrice);
                        return (
                          <div>
                            {bookShow === "Book Appointment" && (
                              <div
                                className="drServiceSp drServiceSp-book generalFlag bookLink"
                                id={"bookLink" + hos.hospitalId}
                                style={{ display: show }}
                              >
                                <span
                                  className="text-decoration-none drServiceSpSpan"
                                  return
                                  onClick={(e) => {
                                    this.isLoginValidate(
                                      this.props.location.doctorId,
                                      hos.hospitalId,
                                      "p",
                                      "No",
                                      "",
                                      ""
                                    );
                                  }}
                                >
                                  <img src={inperson} alt=""></img> In-Person
                                  <span className="drService-rate">
                                    {hos.priceDetails[0].inPersonprice != "0.00" &&
                                      "₹" + hos.priceDetails[0].inPersonprice}
                                  </span>
                                </span>
                              </div>
                            )}
                            {vcShow === "Video Chat" && (
                              <div
                                className="drServiceSp drServiceSp-videochat generalFlag videoLink"
                                id={"videoLink" + hos.hospitalId}
                                style={{ display: show }}
                              >
                                <span
                                  className="text-decoration-none drServiceSpSpan"
                                  onClick={(e) => {
                                    this.isLoginValidate(
                                      this.props.location.doctorId,
                                      hos.hospitalId,
                                      "v",
                                      "No",
                                      "",
                                      ""
                                    );
                                  }}
                                >
                                  <img src={videog} alt=""></img> Video Chat
                                  <span className="drService-rate">
                                    ₹ {hos.priceDetails[0].videoChatPrice}
                                  </span>
                                </span>
                              </div>
                            )}
                            {auShow === "Call a Doctor" && (
                              <div
                                className="drServiceSp drServiceSp-call generalFlag callLink"
                                id={"callLink" + hos.hospitalId}
                                style={{ display: show }}
                              >
                                <span
                                  className="text-decoration-none drServiceSpSpan"
                                  onClick={(e) => {
                                    this.isLoginValidate(
                                      this.props.location.doctorId,
                                      hos.hospitalId,
                                      "c",
                                      "No",
                                      "",
                                      ""
                                    );
                                  }}
                                >
                                  <img src={phoneg} alt=""></img> Audio Chat
                                  <span className="drService-rate">
                                    ₹ {hos.priceDetails[0].audioPrice}
                                  </span>
                                </span>
                              </div>
                            )}
                            {chat === "Messaging" && (
                              <div
                                className="drServiceSp drServiceSp-chat callLinkChat"
                                id={"callLinkChat" + hos.hospitalId}
                                style={{ display: show }}
                              >
                                {hos.priceDetails[0].textChatPrice !== "0.00" ? (
                                  <span
                                    onClick={(e) => {
                                      this.isLoginValidateTextChatWithPayment(
                                        this.props.location.doctorId,
                                        hos.hospitalId,
                                        hos.chatDoctorPanelId,
                                        hos.priceDetails[0].textChatPrice
                                      );
                                    }}
                                    className="text-decoration-none drServiceSpSpan"
                                  >
                                    <img src={chatg} alt=""></img> Text Chat
                                    <span className="drService-rate">
                                      ₹{hos.priceDetails[0].textChatPrice}
                                    </span>
                                    <span className="expireDay">
                                      {this.state.doctorBD.daysOfExpiry &&
                                        "Days of Expiry :" +
                                          this.state.doctorBD.daysOfExpiry}
                                    </span>
                                  </span>
                                ) : (
                                  <span
                                    onClick={() =>
                                      this.chatmessageClick(
                                        this.props.location.doctorId,
                                        hos.hospitalId,
                                        hos.chatDoctorPanelId,
                                        hos.priceDetails[0].textChatPrice
                                      )
                                    }
                                    className="text-decoration-none drServiceSpSpan"
                                  >
                                    <img src={chatg} alt=""></img> Text Chat
                                    <span className="drService-rate">
                                      {" "}
                                      ₹{hos.priceDetails[0].textChatPrice}
                                    </span>
                                    <span className="expireDay">
                                      {this.state.doctorBD.daysofexpiry &&
                                        "Days of Expiry : " +
                                          this.state.doctorBD.daysofexpiry}
                                    </span>
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div> */}
                  </div>
                  <div className="doctorDetailStatement mt-lg-5 mt-md-5 mt-sm-2">
                    <h4 className="sub-heading">
                      About
                    </h4>
                    <p>{this.state.doctorBD.professionalStatement}</p>

                    <h4 className="sub-heading">
                      Info
                    </h4>
                    <p className="font-bold mb-2">Perfect 32 Multispeciality Dental Clinic</p>
                    <p className="mb-0">Housing Colony, Near Pushpanjali Auditorium, Choorakad, Thrippunithura
                      Ernakulam, Kerala, India
                    </p>
                    <p>ZIP - 682301</p>
                    <p className="mt-4">Phone - 6282310276</p>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <Bookappointment />
              </TabPanel>
              <TabPanel>
                <div class="form-head"> </div>
                {this.state.Specialities.map((s) => {
                  return (
                    <ul className="pl-3">
                      <li>{s.specialization ? s.specialization : ""}</li>
                    </ul>
                  );
                })}
                {this.state.Specialities.length === 0 && "No Data Available"}
              </TabPanel>
              <TabPanel>
                <div class="form-head"> </div>
                {this.state.serviceOffered.map((s) => {
                  return <div>{renderHTML(s.serviceOffered)}</div>;
                })}
                {this.state.serviceOffered.length === 0 && "No Data Available"}
              </TabPanel>
              <TabPanel>
                <div class="form-head"> </div>
                {this.state.officeDetails.map((s) => {
                  return <div>{renderHTML(s.officeDetails)}</div>;
                })}
                {this.state.officeDetails.length === 0 && "No Data Available"}
              </TabPanel>
            </Tabs>
          </div>
          {/* <div
            className="drDetailServicemain py-3 text-left"
            style={{ float: "none" }}
          >
            <a href="#">
              <span className="drDetailServiceSpan">
                <img src={speciality} class="imgshow-act" width="22"></img>
                <span className="drDetSpanUnderline">specialities</span>
              </span>
            </a>
            <a href="#">
              <span className="drDetailServiceSpan">
                <img src={service} class="imgshow-act" width="22"></img>
                <span className="drDetSpanUnderline">service offered</span>
              </span>
            </a>
            <a href="#">
              <span className="drDetailServiceSpan">
                <img src={hospital} class="imgshow-act" width="22"></img>
                <span className="drDetSpanUnderline">office details</span>
              </span>
            </a>
          </div> */}
        </div>
        <Suspense fallback={<div></div>}>
          <section>
            <Footer />
          </section>
        </Suspense>
      </div>
    );
  }
}
